import React from "react";

const PageMesServices: React.FC = () => {

return (
  <div className="container text-center">
      <div className="row pt-3 pb-5">
        <div className="col col-12 ">
          <h2 className="titreModule titre-bleu"><i className="bi-boxes pe-2" />Mes Services</h2>
        </div>
      </div>
      <div className="row pt-3 pb-5">
        <div className="col col-md-10 offset-md-1 col-12 ">

        </div>
      </div>
    </div>
  );
}; 

export default PageMesServices;
